import { constants } from 'ha/constants/commonConstants';

export function formatPreferredTenantAge(T, minAge, maxAge) {
  const formattedMaxAge =
    +maxAge >= +constants.maxTenantAge ? `${constants.maxTenantAge}+` : maxAge;

  switch (true) {
    case !!(minAge && maxAge):
      return `${minAge} - ${formattedMaxAge}`;
    case !!(minAge && !maxAge):
      return `${T('at least')} ${minAge}`;
    case !!(!minAge && maxAge):
      return `${T('max.')} ${formattedMaxAge}`;
    default:
      return T('no preference');
  }
}
